import React from 'react';

import { DeliveryMenuScreenV2 } from './DeliveryMenuScreenV2';

// ────────────────────────────────────────────────────────────────────────────────

export const DeliveryMenuScreen = () => {
  return <DeliveryMenuScreenV2 />;
};
